/**
 * Vue filter for price formatting
 */
export function priceFilter(value) {
    const symbols = [
        {value: 1, symbol: ""},
        {value: 1E3, symbol: "K"},
        {value: 1E6, symbol: "M"},
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    let i;
    for (i = symbols.length - 1; i > 0; i--) {
        if (value >= symbols[i].value) {
            break;
        }
    }

    let decimalPlaces = 0;
    if (symbols[i].value >= 1E6) {
        decimalPlaces = 1;
    }
    const formattedValue = (value / symbols[i].value)
        .toFixed(2)
        .replace(rx, "$1");

    return '$' + roundToNearestInteger(formattedValue, decimalPlaces) + symbols[i].symbol;
}

function roundToNearestInteger(number, decimalPlaces) {
    if (!decimalPlaces) {
        return Math.round(number);
    }

    const base = Math.pow(10, decimalPlaces);
    return Math.round(number * base) / base;
}
